
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { modLabel } from './hotkeys';

interface ShortcutRow {
  keys: string;
  parts: string[];
  action: string;
}

@Component
export default class ShortcutsHelp extends Vue {
  @Prop({ type: Boolean, default: false })
  public value!: boolean;

  public get rows(): ShortcutRow[] {
    const mod = modLabel();
    return [
      { keys: `${mod}+K`, parts: [mod, 'K'], action: 'Open / close jump palette' },
      { keys: `${mod}+/`, parts: [mod, '/'], action: 'Show this shortcuts help' },
      { keys: 'Arrows+Enter', parts: ['↑', '↓', '←', '→', '↵'], action: '↑↓ rows · ←→ across row then next/prev row · Enter opens' },
      { keys: 'Tab', parts: ['Tab'], action: 'Pin website as site context (or clear when a site is selected)' },
      { keys: 'Esc', parts: ['Esc'], action: 'Clear query → clear site → close overlay' },
      { keys: 'dns/ssl/mail', parts: ['dns', 'ssl', 'mail'], action: 'With a site selected, load DNS / SSL / mailboxes' },
    ];
  }

  @Watch('value')
  public onOpen(open: boolean): void {
    if (open) {
      this.$nextTick(() => {
        const panel = this.$el.querySelector('.shortcuts-help__panel') as HTMLElement | null;
        if (panel) {
          panel.setAttribute('tabindex', '-1');
          panel.focus();
        }
      });
    }
  }

  public close(): void {
    this.$emit('input', false);
  }

  public async openConsole(): Promise<void> {
    this.close();
    try {
      await this.$router.push({ name: 'website_console' });
    } catch {
      // ignore duplicate navigation
    }
  }
}
